import { responsiveCard } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const uspsStyle = style({
  gap: theme.spacings.m,
  ...responsiveCard({
    400: {
      gap: theme.spacings.l,
    },
    600: {
      gap: theme.spacings.xl,
    },
  }),
});
